import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { linkButtonStyle } from './LinkButton.style';

const LinkButton = ({
  children,
  classes,
  type,
  href,
  size,
  disabled,
  target,
  id,
  isTottusSA,
  isSodimacSA,
  hide,
  onClick,
  ...rest
}) => {
  const className = cx(
    'button',
    `button-${classes}`,
    size && `button-${size}`,
    disabled && 'button-disabled',
    isSodimacSA && 'sodimac-theme',
    isTottusSA && 'tottus-theme',
    hide && 'button-hide'
  );

  const sharedProps = {
    id,
    className,
    ...rest,
  };

  if (type === 'button') {
    return (
      <>
        <button {...sharedProps} type="button" disabled={disabled} onClick={onClick}>
          {children}
        </button>
        <style jsx>{linkButtonStyle}</style>
      </>
    );
  }

  const url = disabled ? '#' : href;
  const handleAnchorClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };
  return (
    <>
      <a {...sharedProps} href={url} target={target} onClick={handleAnchorClick} aria-disabled={disabled || undefined}>
        {children}
      </a>
      <style jsx>{linkButtonStyle}</style>
    </>
  );
};

const LinkLabel = ({ children, type, href, size, disabled, target, id }) => {
  const url = disabled ? '#' : href;
  return (
    <a
      href={url}
      className={`link-button button-${type} button-${size} ${disabled ? 'button-disabled' : ''}`}
      target={target}
      id={id}
    >
      {children}
      <style jsx>{linkButtonStyle}</style>
    </a>
  );
};

LinkLabel.defaultProps = {
  children: null,
  type: 'primary',
  href: '#',
  size: '',
  disabled: false,
  target: '',
  id: '',
};

LinkLabel.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary', 'default']),
  href: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  target: PropTypes.string,
  id: PropTypes.string,
};

LinkButton.defaultProps = {
  children: null,
  classes: 'primary',
  type: 'link',
  href: '#',
  size: 'medium',
  disabled: false,
  target: '',
  id: 'linkButton',
  isTottusSA: false,
  isSodimacSA: false,
  hide: false,
  onClick: () => {},
};

LinkButton.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.oneOf([
    'button',
    'mkp-primary',
    'mkp-secondary',
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'rebranding',
  ]),
  type: PropTypes.oneOf(['button', 'link']),
  href: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  target: PropTypes.string,
  id: PropTypes.string,
  isTottusSA: PropTypes.bool,
  isSodimacSA: PropTypes.bool,
  hide: PropTypes.bool,
  onClick: PropTypes.func,
};

export { LinkLabel };

export { LinkButton };
